import axios from 'axios';

const { REACT_APP_P_API_URL, PORTAAL_API_URL } = process?.env || {};
const baseURL = PORTAAL_API_URL || REACT_APP_P_API_URL || window.location.origin;
const api = axios.create({
    baseURL,
});

export { api, baseURL };
